import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LanguageProvider } from './i18n';
import HomePage from './pages';
import './App.css';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Switch>
            <Route path="/" component={HomePage} exact />
          </Switch>
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;